import React, { FC, memo, useMemo } from 'react';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { validateHbtDataTableCellValue } from '../../Helper';
import { MemoizedHbtDataTableCellProps } from './types';

export const MemoizedHbtDataTableCell: FC<MemoizedHbtDataTableCellProps> = memo(
  ({ dataValue, cellContent, iconClassName }) => {
    const isCellValueValid = useMemo(() => validateHbtDataTableCellValue(dataValue), [dataValue]);

    return !isCellValueValid ? (
      <>{cellContent}</>
    ) : (
      <CmhcIcon type="icon_indeterminate" className={iconClassName} size={CmhcIconSize.MEDIUM} />
    );
  }
);
